import { browser } from "$app/environment";
import { uiApi } from "$lib/ui-api";
import type { ILanguageEntry } from "types/backend/models/admin/settings.entity";
import type { ICountryData } from "types/backend/models/cms/country.entity";

// Country
let countries: ICountryData[] | undefined;
export async function getCountries(): Promise<ICountryData[]> {
  if (countries?.length) {
    return countries;
  }

  const defaultCountries: ICountryData[] = [
    {
      code: "gb",
      name: "United Kingdom",
      callingCode: "+44",
      usesVAT: true,
      currency: "GBP",
    },
  ];
  const resp = await uiApi.getRaw("/z/country-data");
  if (resp.status >= 400) {
    return defaultCountries;
  }
  countries = await resp.json();
  return countries || defaultCountries;
}

// Currency
export async function getCurrencies() {
  const url = `/z/settings/currencies`;
  const resp = await uiApi.getRaw(url);
  if (resp.status >= 400) {
    throw new Error(`could not retrieve currencies settings`);
  }
  return await resp.json();
}

// Languages
let avalableLanguages: ILanguageEntry[];

export async function getAvailableLanguages(): Promise<ILanguageEntry[]> {
  if (avalableLanguages?.length) {
    return avalableLanguages;
  }

  const defaultLanguage: ILanguageEntry[] = [{ name: "English", code: "en" }];
  const resp = await uiApi.getRaw("/z/settings/languages");
  if (resp.status >= 400) {
    return defaultLanguage;
  }
  setAvailableLanguage(await resp.json());
  return avalableLanguages || defaultLanguage;
}

export function setAvailableLanguage(v: ILanguageEntry[]) {
  avalableLanguages = v.sort((a, b) => {
    if (a.code < b.code) {
      return -1;
    } else if (a.code > b.code) {
      return 1;
    }
    // a must be equal to b
    return 0;
  });
}

export function lockPage() {
  document.body.classList.add("lock");
}

export function unlockPage() {
  if (browser) {
    document.body.classList.remove("lock");
  }
}
